import TabToggle from '../../components/shared/tab-toggle';
import ModalHeading from '../../components/shared/modal-heading';
import React, { useEffect, useState } from 'react';
import { createNotifications, deleteNotification } from '../../services/notifications-service';

const DataSettings = ({ data, attributes, notificationTypes, accountId }) => {
    // console.log(attributes);
    // console.log(notificationTypes);

    const [loading, setLoading] = useState(false);
    const [notificationsState, setNotificationsState] = useState(data || []);
    const [apiResponse, setApiResponse] = useState({ message: '', type: '' });

    // State to manage toggle values for each item
    const [toggleStates, setToggleStates] = useState({
        renewal: notificationTypes.renewal?.map(item => ({
            slug: item.slug,
            enabled: data?.some(notification => notification.type === item.slug) || false
        })) || [],
        service: notificationTypes.service?.map(item => ({
            slug: item.slug,
            enabled: data?.some(notification => notification.type === item.slug) || false
        })) || []
    });

    // Find notification ID by slug from data
    const getNotificationIdBySlug = (slug) => {
        const notification = notificationsState.find(n => n.type === slug);
        return notification?.notificationId;
    };


    // Handle toggle change for a specific item
    const handleToggleChange = async (value, slug, section) => {
        const isEnabled = value === 'ON';

        // Update toggle state immediately
        setToggleStates(prev => ({
            ...prev,
            [section]: prev[section].map(item =>
                item.slug === slug ? { ...item, enabled: isEnabled } : item
            )
        }));
        setApiResponse({ message: '', type: '' }); // Clear previous messages

        setLoading(true);
        try {
            if (isEnabled) {
                // Call createNotifications API when toggled to ON
                const response = await createNotifications({ type: slug }, accountId);

                if (response.success) {
                    setApiResponse({ message: 'Notification created successfully!', type: 'success' });
                    // Push new notification with ID into local state
                    setNotificationsState(prev => [
                        ...prev,
                        { notificationId: response.data?.data?.notificationId, type: slug }
                    ]);
                } else {
                    setApiResponse({ message: response.data.message || 'Failed to create notification.', type: 'error' });
                    // Revert toggle state on failure
                    setToggleStates(prev => ({
                        ...prev,
                        [section]: prev[section].map(item =>
                            item.slug === slug ? { ...item, enabled: false } : item
                        )
                    }));
                }
            } else {
                // Call deleteNotification API when toggled to OFF
                const notificationId = getNotificationIdBySlug(slug);
                if (notificationId) {
                    const response = await deleteNotification(accountId, notificationId);
                    console.log(response)
                    if (response.status === 204) {
                        setApiResponse({ message: 'Notification deleted successfully!', type: 'success' });
                        // Remove from local state
                        setNotificationsState(prev =>
                            prev.filter(n => n.notificationId !== notificationId)
                        );
                    } else {
                        setApiResponse({ message: response.data.message || 'Failed to delete notification.', type: 'error' });
                        // Revert toggle state on failure
                        setToggleStates(prev => ({
                            ...prev,
                            [section]: prev[section].map(item =>
                                item.slug === slug ? { ...item, enabled: true } : item
                            )
                        }));
                    }
                } else {
                    setApiResponse({ message: 'No notification found to delete.', type: 'error' });
                    // Revert toggle state if no notification ID found
                    setToggleStates(prev => ({
                        ...prev,
                        [section]: prev[section].map(item =>
                            item.slug === slug ? { ...item, enabled: true } : item
                        )
                    }));
                }
            }
        } catch (error) {
            setApiResponse({ message: 'An unexpected error occurred.', type: 'error' });
            // Revert toggle state on error
            setToggleStates(prev => ({
                ...prev,
                [section]: prev[section].map(item =>
                    item.slug === slug ? { ...item, enabled: !isEnabled } : item
                )
            }));
        } finally {
            setLoading(false);
        }
    };

    // Toggle options for ON/OFF
    const toggleOptions = [
        { value: 'OFF', label: 'OFF' },
        { value: 'ON', label: 'ON' }
    ];

    useEffect(() => {
        if (apiResponse.message) {
            const timer = setTimeout(() => {
                setApiResponse({ message: '', type: '' });
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [apiResponse]);

    return (
        <div>
            <div className="grid grid-cols-1 lg:gap-8 gap-4 md:pt-6 pt-4">
                {/* API Response Message */}
                {apiResponse.message && (
                    <div
                        className={`mb-4 p-3 rounded ${apiResponse.type === "success"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                            }`}
                    >
                        {apiResponse.message}
                    </div>
                )}

                {/* Dynamic Sections */}
                {Object.entries(notificationTypes).map(([sectionKey, sectionItems]) => (
                    <div key={sectionKey} className="mb-8">
                        <div className="mb-6">
                            <ModalHeading className="capitalize">
                                {sectionKey}
                            </ModalHeading>
                            <p className="text-gray-700">
                                Select the Notification option according to your preferences
                            </p>
                        </div>

                        <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
                            {sectionItems.map((item, index) => (
                                <div
                                    key={item.slug}
                                    className="flex justify-between border-b gap-3 py-2 items-center w-full"
                                >
                                    <div className="w-64">
                                        <h1 className="md:text-lg">{item.label}</h1>
                                        <p className="text-gray-600 text-sm">{item.description}</p>
                                    </div>
                                    <TabToggle
                                        options={toggleOptions}
                                        className="!w-[20]"
                                        selected={
                                            toggleStates[sectionKey]?.[index]?.enabled ? "ON" : "OFF"
                                        }
                                        onChange={(val) =>
                                            handleToggleChange(val, item.slug, sectionKey)
                                        }
                                        disabled={loading}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>

    );
};

export default DataSettings;